






















import Vue, { VueConstructor } from 'vue';
import { AxiosResponse } from 'axios';
import services from '@/services';
import { Viewer } from '../../../common/components';

const { UserService } = services;

export default (Vue as VueConstructor<Vue>).extend({
  name: 'Locked',
  components: {
    viewer: Viewer,
  },
  data() {
    return {
      textInfoHeader: 'Account deaktiviert' as string,
      textInfoSubHeader: '' as string,
    };
  },
  created() {
    this.getLockedOutPageInfo();
  },
  methods: {
    getLockedOutPageInfo() {
      UserService.getLockedOutPageInfo().then((result: AxiosResponse<string>) => {
        this.textInfoSubHeader = result.data;
      });
    },
  },
});
